<template>
	<div class="addRedZone">
		<el-card>
			<div class="jump-btn">
				<!-- 返回红色专区列表 -->
				<el-button type="primary" @click="goBack()">{{$t('lang.lab_returnRedZoneList')}}</el-button>
			</div>
			<el-form :rules="rules" ref="form" :model="form" class="form" :label-width="require('@/config/enum').c_ws4"
				:label-suffix="require('@/config/enum').c_colon">
				<!-- 小区列表 -->
				<el-form-item :label="$t('lang.lab_garden')" v-if="id" prop="gardenId">
					<el-select v-model="gardenId">
						<el-option v-for="(item,index) in gardenIdList" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<!-- 标题 -->
				<el-form-item :label="$t('lang.lab_linktitle')" prop="title">
					<el-input v-model="form.title" :placeholder="$t('lang.key_linktitle')" class="input"></el-input>
				</el-form-item>
				<!-- 图片 -->
				<el-form-item :label="$t('lang.lab_image')" ref="image" prop="image">
					<upload-file ref="uploading" :accept='accept' upTypes='1' :fileList='fileList' :clears='clears' @outputFile="getFile"
						@removeFile='removeFile'></upload-file>
				</el-form-item>
				<!-- 选择内外链 -->
				<el-form-item :label="$t('lang.lab_OwnerAround')" prop="inOrExChain">
					<el-radio-group v-model="form.inOrExChain" @change="radioChange">
						<el-radio :label="1">{{$t('lang.lab_OwnerInner')}}</el-radio>
						<el-radio :label="2">{{$t('lang.lab_OwnerWnner')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				<!-- 富文本 -->
				<el-form-item v-show="form.inOrExChain==1" :label="$t('lang.lab_contentNotice')" prop="content">
					<quill-editor v-model="form.content" ref="myQuillEditor" :options="editorOption" @change="onEditorChange($event)"></quill-editor>
					<span class="editorText">{{$t('lang.lab_editor_tip1')}}{{isLength}}{{$t('lang.lab_editor_tip2')}}{{10000-isLength}}{{$t('lang.lab_editor_tip3')}}</span>
				</el-form-item>
				<!-- 超链接 -->
				<el-form-item v-show="form.inOrExChain==2" :label="$t('lang.lab_OwnerWnnerUrl')" prop="url">
					<el-input style="width:50%" class="select" v-model="url" :placeholder="$t('lang.lab_OwnerWnnerUrlTips')"></el-input>
				</el-form-item>

				<el-button @click="rest(form)" class="btn-first">{{$t('lang.btn_rest')}}</el-button>
				<el-button type="primary" @click="onSubmit(form)" class="detailbtn">{{$t('lang.btn_save')}}</el-button>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	import UploadFile from '../../../components/upload_file.vue'
	import {
		addQuillTitle
	} from '../../../config/quill-title.js'
	export default {
		data() {
			var isImage = (rule, value, callback) => {
				if (this.form.image == '' || this.form.image == undefined) {
					callback(new Error(this.$i18n.t('lang.lab_pleaseSeletcUploadDoc')))
				} else {
					callback()
				}
			}

			var validateContent = (rule, value, callback) => {
				if (this.form.inOrExChain == 1) {
					if (value == '') {
						callback(new Error(this.$i18n.t('lang.lab_inputRedZoneContent')))
					} else {
						callback()
					}
				} else {
					callback()
				}
			}
			// eslint-disable-next-line
			var reg = /^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-.,@?^=%&:\/~+#]*[\w\-@?^=%&\/~+#])?$/
			var validatePass = (rule, value, callback) => {
				if (this.form.inOrExChain == 2) {
					if (this.url === undefined) {
						callback(new Error(this.$i18n.t('lang.lab_pleInputLink')))
					} else if (this.url.length > 100) {
						callback(new Error(this.$i18n.t('lang.lab_BigLink100')))
					} else {
						if (!reg.test(this.url)) {
							callback(new Error(this.$i18n.t('lang.lab_pleInputRLink')))
						}
						callback()
					}
				} else {
					callback()
				}
			}
			return {
				gardenId: this.$store.getters.gardenId,
				gardenIdList: this.$store.getters.userGardenList,
				id: '',
				form: {},
				url: '',

				isDisabled: true, // 置灰标识

				fileList: [],
				clears: false, // 图片清空
				accept: '.jpg, .jpeg, .png',

				// 富文本
				editorOption: {
					modules: {
						toolbar: [
							['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
							['blockquote', 'code-block'], // 引用，代码块
							[{
								header: 1
							}, {
								header: 2
							}], // 标题，键值对的形式；1、2表示字体大小
							[{
								list: 'ordered'
							}, {
								list: 'bullet'
							}], // 列表
							[{
								script: 'sub'
							}, {
								script: 'super'
							}], // 上下标
							[{
								indent: '-1'
							}, {
								indent: '+1'
							}], // 缩进
							[{
								direction: 'rtl'
							}], // 文本方向
							[{
								size: ['small', false, 'large', 'huge']
							}], // 字体大小
							[{
								header: [1, 2, 3, 4, 5, 6, false]
							}], // 几级标题
							[{
								color: []
							}, {
								background: []
							}], // 字体颜色，字体背景颜色
							[{
								font: []
							}], // 字体
							[{
								align: []
							}], // 对齐方式
							['clean'], // 清除字体样式
							['image', 'video'] // 上传图片、上传视频
						]
					},
					theme: 'snow',
					placeholder: this.$i18n.t('lang.lab_text'),
				},
				isLength: 0, // 长度

				// 表单验证
				rules: {
					gardenId: [{
						required: true,
						message: this.$i18n.t('lang.lab_chooseGarden'),
						trigger: 'change'
					}],
					title: [{
						required: true,
						message: this.$i18n.t('lang.key_linktitle'),
						trigger: 'blur'
					}],
					inOrExChain: [{
						required: true,
						message: this.$i18n.t('lang.lab_redZonePleaseChance'),
						trigger: 'blur'
					}],
					content: [{
						required: true,
						validator: validateContent,
						trigger: 'blur'
					}],
					url: [{
						required: true,
						validator: validatePass,
						trigger: 'blur'
					}],
					image: [{
						required: true,
						validator: isImage,
						trigger: 'blur'
					}]
				}
			}
		},
		components: {
			'upload-file': UploadFile
		},
		computed: {
			editor() {
				return this.$refs.myQuillEditor.quill
			},
		},
		mounted() {
			this.id = this.$route.query.id

			if (this.id) {
				this.selectRedZoneById()
			}
			addQuillTitle()
		},
		methods: {
			goBack() {
				this.$router.push({
					name: 'redZoneList'
				})
			},
			selectRedZoneById() {
				let loading = this.$loading()
				this.$get(`/selectRedZoneByid/?id=${this.id}`).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.form = res.redZone
							this.gardenId = res.redZone.gardenId
							if (res.redZone.inOrExChain == 2) {
								this.url = res.redZone.content
							}

							if (res.redZone.image && res.redZone.image != '') {
								this.fileList.push({
									name: '',
									url: res.redZone.image.toString()
								})
							}
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			},
			// 获取组件值
			getFile(e) {
				this.form.image = e
				this.$refs.image.clearValidate()
			},
			// 移除图片
			removeFile(e) {
				this.fileList = []
				this.form.image = ''
			},
			// 内容字数提示
			onEditorChange(event) {
				event.quill.deleteText(10000, 4)
				if (this.form.content == '') {
					this.isLength = 0
				} else {
					this.isLength = event.quill.getLength() - 1
				}
				this.manualValidate()
			},

			// 富文本验证
			manualValidate() {
				this.$refs.form.validateField('content')
			},

			radioChange() {
				this.form.content = ''
				this.url = ''
			},
			rest(form) {
				this.fileList = []
				this.clears = true
				this.$refs.form.clearValidate()
				form.title = ''
				form.content = ''
				this.url = ''
			},
			onSubmit(form) {
				this.$refs.form.validate((valid) => {
					if (valid) {
						let loading = this.$loading()
						if (this.id) {
							/* 修改 */
							let param = {
								id: this.id,
								gardenId: this.gardenId,
								image: this.form.image,
								title: this.form.title,
								content: form.inOrExChain == 1 ? this.form.content : this.url,
								inOrExChain: this.form.inOrExChain,
								operPeople: this.$store.getters.staffId
							}
							this.$postJson('/RedZoneEdit', param)
								.then(res => {
									loading.close()
									this.$message.success(this.$i18n.t('lang.lab_save_success'))
									var index = this.$keepAlive.indexOf('/manage/main.redZone')
                  if (index > -1) {
                    this.$keepAlive.splice(index, 1)
                  }
									this.$router.push({
										name: 'redZoneList'
									})
								})
								.catch(err => {
									loading.close()
									this.$message.error(err)
								})
						} else {
							/* 添加 */
							let param = {
								gardenId: this.gardenId,
								image: this.form.image,
								title: this.form.title,
								content: form.inOrExChain == 1 ? this.form.content : this.url,
								inOrExChain: this.form.inOrExChain,
								createPeople: this.$store.getters.staffId,
								operPeople: this.$store.getters.staffId
							}
							this.$postJson('/RedZoneAdd', param)
								.then(res => {
									loading.close()
									this.$message.success(this.$i18n.t('lang.lab_save_success'))
									var index = this.$keepAlive.indexOf('/manage/main.redZone')
                  if (index > -1) {
                    this.$keepAlive.splice(index, 1)
                  }
									this.$router.push({
										name: 'redZoneList'
									})
								})
								.catch(err => {
									loading.close()
									this.$message.error(err)
								})
						}
					} else {
						return false
					}
				})
			}
		}

	}
</script>

<style lang="scss">
	.addRedZone {
		.input {
			width: 30%;
		}

		.el-form-item__content {
			width: 60vw !important;
		}

		.select {
			width: 30%;
		}
	}
</style>
